import { Injectable } from '@angular/core';
import { snackbarService } from '@one/web-components';
@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor() { }

  snackBarMessage(status: any, message: string) {
        snackbarService.show({
          message: message,
          snackbarProps: {
            status: status,
            direction: 'horizontal',
            showClose: true,
            elevated: false,
            duration: 5000,
            verticalPlacement: 'top',
            horizontalPlacement: 'right',
          }
        });
      }
}
